import { delay } from 'utils';
import { EventHandler, WatcherHandler } from './../types';
import { event, watch, getProgressLevel } from './../helpers';

const EVENT_BASED: EventHandler[] = [
  event(
    'ANALYTICS_INIT',
    ({ set, $store }) => {
      set('game_ready_timing', Math.round(window.performance.now()));
      set('music_active', $store.state.settings.music);
      set('sfx_active', $store.state.settings.sfx);
      if ($store.getters.totalProgress === $store.getters.prime.length) {
        set('engagement', 'game_ready');
      }
    },
  ),
  event(
    'PLAY',
    ({ set, $store }) => {
      const current = $store.getters.totalProgress;
      const primes = $store.getters.prime.length;
      if (current === primes) {
        set('engagement', 'play_clicked');
      } else if (current === primes + 1) {
        set('engagement', 'tutorials_finished');
      } else if (current >= primes + 2) {
        set('engagement', 'own_element');
      }

      const progressLevel = getProgressLevel(current);
      if (progressLevel) {
        set('progress', progressLevel);
      }
    },
  ),
  event(
    'MIX_NEW',
    async ({ set, $store }) => {
      await delay(500);
      const initial = $store.getters.sessionStats.initialProgress;
      const current = $store.getters.totalProgress;
      const sessionProgress = current - initial;

      set('session_progress', sessionProgress);

      if (current === $store.getters.prime.length + 2) {
        set('engagement', 'own_element');
      }

      const progressLevel = getProgressLevel(current);
      if (progressLevel) {
        set('progress', progressLevel);
      }
    },
  ),
  event(
    'LOGGED_IN',
    ({ set }) => set('logged_in', true),
  ),
  event(
    'NOT_LOGGED_IN',
    ({ set }) => set('logged_in', false),
  ),
  event(
    'TUTORIALS_FINISHED',
    ({ set }) => set('engagement', 'tutorials_finished'),
  ),
  event(
    'TUTORIALS_PROGRESS',
    ({ set }, { type, name }) => set('engagement', `tutorial_${ type }_${ name }`),
  ),
  event(
    'ANIMATION_NEW_POP',
    ({ set, $store }) => {
      if ($store.getters.totalProgress > 5) return;

      set('engagement', 'first_new_animation_pop');
    },
  ),
  event(
    'ANIMATION_NEW_END',
    ({ set, $store }) => {
      if ($store.getters.totalProgress > 5) return;

      set('engagement', 'first_new_animation_end');
    },
  ),
  event(
    'HINTS_CLICKED',
    ({ set }) => set('engagement', 'hints_clicked'),
  ),
  event(
    'GAME_ENDED',
    ({ set }) => set('engagement', 'game_ended'),
  ),
  event(
    'GAME_COMPLETED',
    ({ set }) => set('engagement', 'game_completed'),
  ),
];

const STORE_BASED: WatcherHandler[] = [
  watch(
    (getters) => getters.playMusic,
    ({ set }, isActive) => set('music_active', isActive),
  ),
  watch(
    (getters) => getters.playSfx,
    ({ set }, isActive) => set('sfx_active', isActive),
  ),
];

const ALL: Array<WatcherHandler | EventHandler> = [...EVENT_BASED, ...STORE_BASED];
export default ALL;
